import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a40b708c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "invest-tabel" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "invest-tabel-title" }, "非会员拎包培训报名", -1))
const _hoisted_3 = { class: "traning-tabel-line" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 单 ")
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/_createTextVNode("男")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("女")
const _hoisted_8 = { class: "traning-tabel-line" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 个 ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("保存")

import { defineComponent } from "vue";
import store from "@/store/index";
import { useStore } from "@/store/index";
import { ref, reactive } from "vue";
import { ElButton, ElMessage, ElMessageBox } from "element-plus";
import type { ElForm, Action } from "element-plus";
import Bottom from '../components/bottom.vue'
import { MoreFilled } from '@element-plus/icons-vue'

import tool from "@/utils/tool";
import router from "@/router/index";
import { Plus } from '@element-plus/icons-vue'
import type { UploadFile, ElFile } from 'element-plus/es/components/upload/src/upload.type'

type FormInstance = InstanceType<typeof ElForm>;

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const radio1 = ref('1')
const active = 0;
const activitiesStep = [
  {
    content: '报名',
    timestamp: '2018-04-12 20:46',
    size: 'large',
    type: 'primary',
    icon: MoreFilled,
  },
  {
    content: '缴费',
    timestamp: '2018-04-03 20:46',
    color: '#0bbd87',
  },
  {
    content: '成功',
    timestamp: '2018-04-03 20:46',
    size: 'large',
  },
];

const isDisabled = ref(false);

var id = router.currentRoute.value.params.id;
if (typeof id == "string") {
  store.dispatch("frontTrainingModule/getActivityApply", { activityId: id }).then(
    (data) => {
      //成功
      if (data.result != null) {
        bindData.activityApplyForm = data.result;
        bindData.activityApplyForm.joinCategoryIdsArray = data.result.joinCategoryIds.split(",");
        isDisabled.value = true;
      }
    },
    (error) => {
      console.log(error.msg);
    }
  );
}

store.dispatch("frontInvestModule/listJoinCategory", {}).then(
  (data) => {
    //成功
    if (data.result != null) {
      bindData.joinCategoryList = data.result;
    }
  },
  (error) => {
    console.log(error.msg);
  }
);

const activityApplyFormRef = ref<FormInstance>();

const ustore = useStore();

const bindData = reactive({
  memberName: '',
  joinCategoryList: [],
  activityApplyForm: {
    activityId: '',
    contact: '',
    mobile: '',
    identityCardNo: '',
    explanation: '',
    joinCategoryIdsArray: [],
    joinCategoryIds: '',
    identityCardPhoto: "",
    identityCardPhotoUrl: "",
    job: "",
    projectNumber: 0,
    turnover: '',
    brandName: '',
    companyName: '',
    sex: 1,
  }
});

if (typeof id == "string") {
  bindData.activityApplyForm.activityId = id;
}

bindData.memberName = ustore.state.loginMember == undefined ? '' : ustore.state.loginMember.companyName

const defaultValidate = (rule: any, value: any, callback: any) => {
  if (value === "") {
    callback(new Error("请填写联系人"));
  } else {
    callback();
  }
};

const activityApplyRules = reactive({
  contact: [{ required: true, validator: defaultValidate, trigger: "blur" }],
  mobile: [{ required: true, message: '请填写电话', trigger: "blur" }],
});

const submitForm = (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  formEl.validate((valid) => {
    if (valid) {
      bindData.activityApplyForm.joinCategoryIds = bindData.activityApplyForm.joinCategoryIdsArray.join(',');
      store.dispatch("frontTrainingModule/unloginSaveActivityApply", bindData.activityApplyForm).then(
        (data) => {
          //成功
          ElMessage.success("保存成功.");
          isDisabled.value = true;
        },
        (error) => {
          ElMessageBox.alert(error.msg, "系统消息", {
            confirmButtonText: "关闭",
            callback: (action: Action) => { },
          });
        }
      );
    } else {
      console.log("error submit!");
      return false;
    }
  });
};

const beforeUploadCheckEvent = (file: ElFile) => {
  let types = ["image/jpeg", "image/gif", "image/bmp", "image/png"];
  const isImage = types.includes(file.type);
  const isLt2M = file.size / 1024 / 1024 < 2;

  if (!isImage) {
    ElMessage.error("上传的图片必须是JPG,GIF,BMP,PNG格式!");
  }
  if (!isLt2M) {
    ElMessage.error("上传的图片文件大小不能超过2MB!");
  }
  return isImage && isLt2M;
};

const handleEdit = () => {
  isDisabled.value = false;
};

const handleCardFrontFileSuccess = (
  response: any,
  file: UploadFile,
  fileList: UploadFile[]
) => {
  bindData.activityApplyForm.identityCardPhoto = response.result;
  bindData.activityApplyForm.identityCardPhotoUrl = URL.createObjectURL(file.raw);
};

const resetForm = (formEl: FormInstance | undefined) => {
  console.log("exec...resetForm");
  if (!formEl) return;
  formEl.resetFields();
};


return (_ctx: any,_cache: any) => {
  const _component_el_step = _resolveComponent("el-step")!
  const _component_el_steps = _resolveComponent("el-steps")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode(_component_el_steps, {
        active: active,
        "finish-status": "success"
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(activitiesStep, (activityStep, index) => {
            return _createVNode(_component_el_step, {
              key: index,
              title: activityStep.content
            }, null, 8, ["title"])
          }), 64))
        ]),
        _: 1
      }),
      _createVNode(_component_el_form, {
        class: "invest-tabel-ct",
        model: _unref(bindData).activityApplyForm,
        ref_key: "activityApplyFormRef",
        ref: activityApplyFormRef,
        "label-width": "200px",
        "status-icon": "",
        rules: _unref(activityApplyRules)
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, { label: "公司名称" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _unref(bindData).activityApplyForm.companyName,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(bindData).activityApplyForm.companyName) = $event)),
                prop: "companyName",
                "input-style": "width:300px",
                placeholder: "",
                size: "default",
                disabled: isDisabled.value
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "经营品类",
            prop: "joinCategoryIdsArray"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_checkbox_group, {
                modelValue: _unref(bindData).activityApplyForm.joinCategoryIdsArray,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(bindData).activityApplyForm.joinCategoryIdsArray) = $event)),
                disabled: isDisabled.value
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).joinCategoryList, (joinCategory) => {
                    return (_openBlock(), _createBlock(_component_el_checkbox, {
                      key: joinCategory.id,
                      label: joinCategory.id
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(joinCategory.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["label"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "经营品牌" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _unref(bindData).activityApplyForm.brandName,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(bindData).activityApplyForm.brandName) = $event)),
                prop: "brandName",
                "input-style": "width:300px",
                placeholder: "",
                size: "default",
                disabled: isDisabled.value
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "上年销量" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_el_input, {
                  modelValue: _unref(bindData).activityApplyForm.turnover,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(bindData).activityApplyForm.turnover) = $event)),
                  prop: "turnover",
                  "input-style": "width:100px;margin-right: 10px",
                  placeholder: "",
                  size: "default",
                  disabled: isDisabled.value
                }, null, 8, ["modelValue", "disabled"]),
                _hoisted_4
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "证件照片" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_container, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_upload, {
                    class: _normalizeClass(["avatar-uploader", _unref(bindData).activityApplyForm.identityCardPhoto && 'cur-uploader']),
                    action: _unref(tool).url('/personalCenter/uploadImageFile'),
                    "show-file-list": false,
                    "on-success": handleCardFrontFileSuccess,
                    "before-upload": beforeUploadCheckEvent,
                    disabled: isDisabled.value
                  }, {
                    default: _withCtx(() => [
                      (_unref(bindData).activityApplyForm.identityCardPhoto)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: _unref(bindData).activityApplyForm.identityCardPhotoUrl,
                            class: "avatar"
                          }, null, 8, _hoisted_5))
                        : (_openBlock(), _createBlock(_component_el_icon, {
                            key: 1,
                            class: "avatar-uploader-icon"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(Plus))
                            ]),
                            _: 1
                          }))
                    ]),
                    _: 1
                  }, 8, ["class", "action", "disabled"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "姓名" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _unref(bindData).activityApplyForm.contact,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(bindData).activityApplyForm.contact) = $event)),
                prop: "contact",
                "input-style": "width:300px",
                placeholder: "",
                size: "default",
                disabled: isDisabled.value
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "性别" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_radio_group, {
                modelValue: _unref(bindData).activityApplyForm.sex,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(bindData).activityApplyForm.sex) = $event)),
                disabled: isDisabled.value
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio, {
                    label: 1,
                    size: "default"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_radio, {
                    label: 2,
                    size: "default"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "身份证号码" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _unref(bindData).activityApplyForm.identityCardNo,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(bindData).activityApplyForm.identityCardNo) = $event)),
                prop: "identityCardNo",
                "input-style": "width:300px",
                placeholder: "",
                size: "default",
                disabled: isDisabled.value
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "公司职务" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _unref(bindData).activityApplyForm.job,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(bindData).activityApplyForm.job) = $event)),
                prop: "job",
                "input-style": "width:300px",
                placeholder: "",
                size: "default",
                disabled: isDisabled.value
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "电话" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _unref(bindData).activityApplyForm.mobile,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(bindData).activityApplyForm.mobile) = $event)),
                prop: "mobile",
                "input-style": "width:300px",
                placeholder: "",
                size: "default",
                disabled: isDisabled.value
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "经历过的拎包项目数" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_el_input, {
                  modelValue: _unref(bindData).activityApplyForm.projectNumber,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(bindData).activityApplyForm.projectNumber) = $event)),
                  prop: "projectNumber",
                  "input-style": "width:100px;margin-right: 10px",
                  placeholder: "",
                  size: "default",
                  disabled: isDisabled.value
                }, null, 8, ["modelValue", "disabled"]),
                _hoisted_9
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"]),
      _createVNode(_component_el_container, { class: "invest-tabel-btn" }, {
        default: _withCtx(() => [
          (isDisabled.value)
            ? (_openBlock(), _createBlock(_unref(ElButton), {
                key: 0,
                type: "info",
                size: "large",
                onClick: handleEdit
              }, {
                default: _withCtx(() => [
                  _hoisted_10
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_unref(ElButton), {
                key: 1,
                type: "primary",
                size: "large",
                onClick: _cache[10] || (_cache[10] = ($event: any) => (submitForm(activityApplyFormRef.value)))
              }, {
                default: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 1
              }))
        ]),
        _: 1
      })
    ]),
    _createVNode(Bottom)
  ]))
}
}

})